<template>
  <div class="baseEdit">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="0">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ $t('sbRateConfig.collapseTitle.basicTitle') }}</div
          >
        </template>
        <div class="collapse-content">
          <BasicInfo :canEdit="canEdit" ref="basicInfo" />
        </div>
      </el-collapse-item>
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ $t('sbRateConfig.collapseTitle.detailTitle') }}</div
          >
        </template>
        <div class="collapse-content">
          <DetailInfo :canEdit="canEdit" ref="detailInfo" />
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="fixed-bottom-btnList">
      <el-button
        v-hasPermi="['2021050811243179091']"
        v-if="this.$route.name.indexOf('Detail') != -1"
        type="primary"
        @click="canEdit = !canEdit"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.editToggle') }}</el-button
      >
      <el-button
        v-hasPermi="['2021050811244073858']"
        type="primary"
        @click="save()"
        :disabled="!canEdit"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.save') }}</el-button
      >
    </div>
  </div>
</template>
<script>
  import API from '@/api/capitalCenter/settle';
  import BasicInfo from './components/basicInfo'; // 基本信息
  import DetailInfo from './components/detailInfo'; // 费用明细
  export default {
    name: 'baseEdit',
    components: {
      BasicInfo, // 基本信息
      DetailInfo, // 费用明细
    },
    data() {
      return {
        activeNames: ['0', '1'],
        canEdit: true,
      };
    },
    mounted() {
      if (this.$route.query.id) {
        this.getDetail();
      }
      if (this.$route.name.indexOf('Detail') != -1) {
        this.canEdit = false;
      }
    },
    methods: {
      importDetail(allDetail) {
        let tableData = allDetail;
        let basicInfo = this.$refs.basicInfo.baseData;
        Object.keys(basicInfo).map((item) => {
          return (basicInfo[item] = tableData[0][item]);
        });
        this.$refs.detailInfo.tableData = tableData;
      },
      async getDetail() {
        // 请求详情
        this.loading.startLoading();
        let res = await this.$axios.get(
          `${API.QUERY_SETTLRINTERESTRATECONFIG_BY_ID}?id=${this.$route.query.id}`
        );
        if (res) {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.importDetail(res.data.data);
          } else {
            this.$alert(res.data.msg);
          }
        }
      },
      async save() {
        // 保存
        let basicInfo = this.$refs.basicInfo.exportChildData();
        let list = await this.$refs.detailInfo.exportChildData();
        if (basicInfo && list) {
          let params = this.$baseRequest.assignObj({ ...basicInfo, list });
          this.loading.startLoading();
          let res = await this.$axios.post(API.SAVE_SETTLRINTERESTRATECONFIG, params);
          if (res) {
            this.loading.endLoading();
            if (res.data.code == 0) {
              this.$message({ showClose: true, type: 'success', message: res.data.msg });
              this.importDetail(res.data.data);
            } else {
              this.$message({ showClose: true, type: 'error', message: res.data.msg });
            }
          }
        }
      },
    },
  };
</script>
